import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { CheckCircle, XCircle, Trash2 } from 'lucide-react';

const DAY_LABELS = { day1: 'Sept 6', day2: 'Sept 7', day3: 'Sept 8' };

const Field = ({ label, value, className = '' }) => (
  <div className={className}>
    <p className="text-sm font-semibold blue-text opacity-60">{label}</p>
    <p className="blue-text">{value}</p>
  </div>
);

export const RSVPCard = ({ rsvp, onDelete }) => (
  <Card className="border-2 border-primary cream-bg" data-testid={`rsvp-card-${rsvp.id}`}>
    <CardHeader className="pb-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <CardTitle className="text-2xl blue-text">
            {rsvp.firstName} {rsvp.lastName}
          </CardTitle>
          {rsvp.attending === 'yes' ? (
            <CheckCircle className="w-6 h-6 text-green-600" />
          ) : (
            <XCircle className="w-6 h-6 text-red-600" />
          )}
        </div>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => onDelete(rsvp.id, `${rsvp.firstName} ${rsvp.lastName}`)}
          className="border-2 border-red-500 text-red-600 hover:bg-red-50"
          data-testid={`delete-rsvp-${rsvp.id}`}
        >
          <Trash2 className="w-4 h-4 mr-2" />
          Delete
        </Button>
      </div>
    </CardHeader>
    <CardContent>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Field label="Email" value={rsvp.email} />
        {rsvp.phone && <Field label="Phone" value={rsvp.phone} />}
        <Field label="Status" value={rsvp.attending === 'yes' ? 'Attending' : 'Declining'} />
        {rsvp.attending === 'yes' && rsvp.attendingDays?.length > 0 && (
          <Field label="Attending Days" value={rsvp.attendingDays.map(d => DAY_LABELS[d] || d).join(', ')} />
        )}
        {rsvp.bringingKids && rsvp.numberOfKids > 0 && (
          <Field label="Bringing Kids" value={`Yes - ${rsvp.numberOfKids} ${rsvp.numberOfKids === 1 ? 'child' : 'children'}`} />
        )}
        {rsvp.dietaryRestrictions && rsvp.dietaryRestrictions !== 'none' && (
          <Field
            label="Dietary Restrictions"
            value={`${rsvp.dietaryRestrictions}${rsvp.dietaryDetails ? ` - ${rsvp.dietaryDetails}` : ''}`}
            className="md:col-span-2"
          />
        )}
        {rsvp.message && (
          <div className="md:col-span-3">
            <p className="text-sm font-semibold blue-text opacity-60">Message</p>
            <p className="blue-text italic">"{rsvp.message}"</p>
          </div>
        )}
      </div>
      <div className="mt-4 pt-4 border-t border-primary">
        <p className="text-xs blue-text opacity-60">
          Submitted: {new Date(rsvp.submittedAt).toLocaleDateString('en-US', {
            year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'
          })}
        </p>
      </div>
    </CardContent>
  </Card>
);
